import { SearchIncrement } from './searchIncrement';
import { ListType } from './filterTop';
import { SearchSettings } from './searchSettings';
import * as _ from 'lodash';

export interface SearchParams {
    allseasons: boolean;
    almacen: string;
    busqueda2: string;
    busqueda: string;
    categoria: string;
    cliente: string;
    codigoVelocidad2: string;
    codigoVelocidad: string;
    codigoms: boolean;
    coste?: boolean;
    currentListType?: ListType;
    diesag: string;
    dipos: string;
    direccionEnvio: number;
    diuso: string;
    electric: boolean;
    emparejar: string;
    equivalences: boolean;
    estructura: string;
    gama: string;
    gamaLabel: string;
    homologaciones: string;
    iccvsuperiores: boolean;
    ice: boolean;
    increment: SearchIncrement;
    indiceCarga2: string;
    indiceCarga: string;
    inmediata: boolean;
    invierno: boolean;
    marca: string;
    marcasName: string;
    numRuedas: number;
    obsoletos: number;
    ocultarIncremento: boolean;
    ordenBusqueda: number;
    pagina: string;
    posicion: string;
    protector: boolean;
    pvr?: boolean;
    runflat: boolean;
    sealInside: boolean;
    sec: string;
    snow: boolean;
    specialOffers: boolean;
    stock: string;
    stock_minimo: number;
    tipoArticulo: string;
    tipoVehiculo: string;
    uso: string;
    verano: boolean;
    withoutRunflat: boolean;
    tipoTurismo: boolean;
    tipoFurgoneta: boolean;
    tipo4x4: boolean;
    semiSlick: boolean;
}

export class SearchParamsHelper {
    static create(): SearchParams {
        return {
            allseasons: false,
            almacen: null,
            busqueda2: '',
            busqueda: '',
            categoria: '',
            cliente: null,
            codigoVelocidad2: '',
            codigoVelocidad: '',
            codigoms: false,
            coste: false,
            currentListType: ListType.small,
            diesag: '',
            dipos: '',
            direccionEnvio: null,
            diuso: '',
            electric: false,
            emparejar: '',
            equivalences: false,
            estructura: '',
            gama: '',
            gamaLabel: '',
            homologaciones: '',
            iccvsuperiores: false,
            ice: false,
            increment: new SearchIncrement(),
            indiceCarga2: '',
            indiceCarga: '',
            inmediata: false,
            invierno: false,
            marca: '',
            marcasName: '',
            numRuedas: 0,
            obsoletos: 0,
            ocultarIncremento: false,
            ordenBusqueda: 0,
            pagina: '',
            posicion: '',
            protector: false,
            pvr: false,
            runflat: false,
            sealInside: false,
            sec: '',
            snow: false,
            specialOffers: false,
            stock: '',
            stock_minimo: 2,
            tipoArticulo: '',
            tipoVehiculo: '',
            uso: '',
            verano: false,
            withoutRunflat: false,
            tipoTurismo: false,
            tipoFurgoneta: false,
            tipo4x4: false,
            semiSlick: false
        };
    }

    static fromSearchSettings(searchParamsOrg: SearchParams, settings: SearchSettings): SearchParams {
        const searchParams = _.cloneDeep(searchParamsOrg);

        searchParams.numRuedas = settings['numRuedas'];
        searchParams.equivalences = settings['equivalenciasDefault'];
        searchParams.iccvsuperiores = settings['filtroICCVSuperiores'];
        searchParams.stock = settings['predetConStock'];
        searchParams.stock_minimo = settings['stock_minimo'];
        searchParams.ordenBusqueda = settings['ordenBusqueda'];
        searchParams.coste = settings['mostrarCoste'];
        searchParams.pvr = settings['mostrarPVR '];
        searchParams['increment'].value = settings.incremento_cantidad;
        searchParams['increment'].type = settings.incremento_tipo;

        searchParams.currentListType = settings.tipoResultadoBusqueda === 'AVANZADO' ? ListType.big : ListType.small;

        searchParams.mostrarCantidadBusqueda = settings['mostrarCantidadBusqueda']
            ? settings['mostrarCantidadBusqueda']
            : 1;

        return searchParams;
    }

    // para la llamada al endpoint de los checks
    static toAPIChecks(searchParams: SearchParams) {
        return {
            ALLSEASONS: searchParams.allseasons ? 1 : 0,
            BUSQUEDA: searchParams.busqueda,
            CATEGORIA: searchParams.categoria || null,
            CLIENTE: searchParams.cliente || null,
            CODIGOMS: searchParams.codigoms ? 1 : 0,
            CODIGOVELOCIDAD: searchParams.codigoVelocidad || null,
            CODIGOVELOCIDAD2: searchParams.codigoVelocidad2 || null,
            ELECTRICO: searchParams.electric || null,
            ESTRUCTURA: searchParams.estructura || null,
            GAMA: searchParams.gama || null,
            HOMOLOGACIONES: searchParams.homologaciones || null,
            HIELO: searchParams.ice || null,
            ICCVSUPERIORES: searchParams.iccvsuperiores ? 1 : 0,
            INDICECARGA: searchParams.indiceCarga || null,
            INDICECARGA2: searchParams.indiceCarga2 || null,
            INVIERNO: searchParams.invierno ? 1 : 0,
            MARCA: searchParams.marca || '',
            NIEVE: searchParams.snow || null,
            NORUNFLAT: searchParams.withoutRunflat ? 1 : 0,
            POSICION: searchParams.posicion || null,
            PROTECTOR: searchParams.protector || null,
            RUNFLAT: searchParams.runflat ? 1 : 0,
            SEALINSIDE: searchParams.sealInside || null,
            TIPOVEHICULO: searchParams.tipoVehiculo || null,
            USO: searchParams.uso || null,
            VERANO: searchParams.verano ? 1 : 0,
            SEMI_SLICK: searchParams.semiSlick ? 1 : 0
        };
    }

    static resetFiltros(searchParamsOrg: SearchParams, resetTipoVehiculo: boolean = true): SearchParams {
        return {
            ...searchParamsOrg,
            allseasons: false,
            invierno: false,
            verano: false,
            runflat: false,
            codigoms: false,
            sealInside: false,
            protector: false,
            snow: false,
            electric: false,
            homologaciones: '',
            gama: '',
            posicion: '',
            uso: '',
            estructura: '',
            semiSlick: false,
            tipo4x4: false,
            tipoFurgoneta: false,
            tipoTurismo: false,
            tipoVehiculo: resetTipoVehiculo ? '' : searchParamsOrg.tipoVehiculo,
            specialOffers: false
        };
    }
}
